function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

const checkStock = debounce((variant) => {
    const currentStock = parseInt($('#productSelect option:selected').data('stock')) ?? 0;

    $('#productVariantStock').remove();
    if(variant.inventory_management === 'shopify' && currentStock > 0){
        waitForElm('.stock-top').then(() => {
            $('#productVariantStock').remove();
            $('.btn-action.qty-cart').before(`<div id="productVariantStock" class="stock-top mb-2"><strong>${currentStock}</strong> in stock for this selection</div>`);
        });
    }
});

// Trigger the slick gallery to go to the correct slide
const processSlickVariant = debounce((variant) => {
    const position = variant.featured_image?.position;
    const slickIndex = $('.engoj_img_main[data-position="' + position + '"]').parent().data('slickIndex');
    if($('.js_prod_main').length > 0){
        $('.js_prod_main').slick('slickGoTo', slickIndex);
    }

    if($('.js_prod_main_bot').length > 0){
        $('.js_prod_main_bot').slick('slickGoTo', slickIndex);
    }
});

(function($){

    // ----
    // Purpose of the following script... Removing sold out product variants from the dropdowns
    // - Using ideas from https://help.shopify.com/en/manual/online-store/themes/themes-by-shopify/vintage-themes/customizing-vintage-themes/hide-sold-out-variants
    // ----
    const productJson = window.productJson;
    if (productJson !== undefined) {
        const isDiscs = Boolean(productJson.options.length > 0 && productJson.options.includes('Plastic'));
        const availableVariants = [];

        // Only apply the following to discs
        if(isDiscs){
            // Grab available variants
            if(productJson.variants !== undefined && productJson.variants.length > 0){
                for(let i = 0; i < productJson.variants.length; i++){
                    for (let j = 0; j < productJson.variants.length; j++) {
                        const variant = productJson.variants[j];

                        if (variant.available) {
                            availableVariants.push(variant);
                        }
                    }
                }
            }

            // Sort the remaining available variants
            if (availableVariants.length > 0) {
                waitForElm('#productSelect').then(() => {
                    const variantOptions = document.querySelectorAll('#productSelect option');
                    const variantJson = [];

                    if (variantOptions.length > 0) {
                        for (let l = 0; l < variantOptions.length; l++) {
                            const option = variantOptions[l];

                            variantJson.push({
                                label: option.innerHTML,
                                value: option.value,
                                selected: option.selected,
                                plastic: option.dataset.plastic,
                                weight: parseInt(option.dataset.weight),
                                color: option.dataset.color,
                                stock: option.dataset.stock
                            });
                        }

                        // Sort the variants by Plastic A-Z | Weight low-high | Color A-Z
                        variantJson.sort((a,b)=> (a.plastic.localeCompare(b.plastic) || a.weight - b.weight || a.color.localeCompare(b.color)));

                        // Rebuild options
                        const productSelect = document.querySelector('#productSelect');
                        productSelect.options.length = 0;
                        variantJson.forEach((item, i) => {
                            const option = new Option(item.label, item.value, false, item.selected);
                            option.dataset.plastic = item.plastic;
                            option.dataset.weight = item.weight;
                            option.dataset.color = item.color;
                            option.dataset.stock = item.stock;
                            productSelect.appendChild(option);
                        });
                    }
                    return;
                });
            }

            // Hide select if there is no available variants
            if(document.querySelectorAll('#productSelect option').length === 0){
                $('#productSelect').wrap('<div style="display:none"></div>');
            }

            // Remove unavailable images by only showing available variants
            if(availableVariants.length > 1){
                waitForElm('.js_prod_sub').then(() => {
                    for (let k = 0; k < availableVariants.length; k++) {
                        const availableVariant = availableVariants[k];

                        $('.js_prod_sub .prod_sub[data-position="' + availableVariant?.featured_image?.position + '"]').addClass('keep').attr('data-variant', availableVariant.id);
                    }

                    $('.js_prod_sub .prod_sub:not(.keep)').remove();
                    return;
                });

                waitForElm('.js_prod_main').then(() => {
                    for (let k = 0; k < availableVariants.length; k++) {
                        const availableVariant = availableVariants[k];

                        $('.js_prod_main img[data-position="' + availableVariant?.featured_image?.position + '"]').addClass('keep').attr('data-variant', availableVariant.id);
                    }
                    $('.js_prod_main img:not(.keep)').parent().remove();
                    return;
                });

                waitForElm('.js_prod_main_bot').then(() => {
                    for (let k = 0; k < availableVariants.length; k++) {
                        const availableVariant = availableVariants[k];

                        $('.js_prod_main_bot img[data-position="' + availableVariant?.featured_image?.position + '"]').addClass('keep').attr('data-variant', availableVariant.id);
                    }
                    $('.js_prod_main_bot img:not(.keep)').parent().remove();
                    return;
                });
            }
        }

        // ----
        // Purpose of the following script... Update swatches/image on product variant option select
        // ----
        $(document).on('change', '#productSelect', function(){
            const currentVariant = parseInt($(this).val());
            const form = $('form[action*="/cart/add"]');

            if(productJson.variants !== undefined && productJson.variants.length > 0){
                for(let i = 0; i < productJson.variants.length; i++){
                    for (let j = 0; j < productJson.variants.length; j++) {
                        const variant = productJson.variants[j];

                        if(variant.id === currentVariant){
                            for (var k=0,length=variant.options.length; k<length; k++) {
                                  var radioButton = form.find('.swatch[data-option-index="' + k + '"] :radio[value="' + variant.options[k] +'"]');
                                  if (radioButton.size()) {
                                      radioButton.prop('checked', true);
                                      radioButton.trigger('change');
                                  }
                            }

                            checkStock(variant);
                            return;
                        }
                    }
                }
            }
        });
        $('#productSelect').trigger('change'); // Initialise select

        // Trigger variant in the product select for a provided variant id
        const selectOptionFromVariantId = debounce((variantId) => {
            if(variantId !== undefined){
                $('#productSelect').val(variantId);
                $('#productSelect').trigger('change');
            }
        });

        // Trigger variant in the product select from the image being clicked in gallery sliders
        $(document).on('click', '.js_prod_main img, .js_prod_sub .prod_sub, .js_prod_main_bot img', function(){
            selectOptionFromVariantId($(this).data('variant'));
        });

        // Replace colours with hex codes from another
        if($('.swatch-element .link_color').length > 0){
            $('.swatch-element .link_color').each(function(item, i) {
                const color = $(this).data('color');
                if(window.variantColours[color] !== undefined){
                    $(this).css('background-color', window.variantColours[color]);
                }
            });
        }
    }

})(jQuery);